<template>
  <div class="likes-container">
    <span
      class="movie-widget"
      style="cursor: pointer"
      @click.prevent="like"
    >
      <i
        class="fas fa-thumbs-up fa-sm text--white"
        v-if="liked"
        style="color: #fff; font-size: 20px"
      ></i>
      <i
        class="las la-thumbs-up fa-sm text--white"
        v-else
      ></i>
      <span class="movie-widget__value">{{ likes_count }}</span>
    </span>

    <span
      class="movie-widget dislike"
      style="cursor: pointer"
    >
      <i class="las la-thumbs-down fa-sm text--white"></i>
      <span class="movie-widget__value">0</span>
    </span>
  </div>
</template>

<script>
import axios from 'axios';
import decrypt from './decrypt';
export default {
  props: ['auth', 'item', 'likes_count', 'is_liked', 'has_episode'],
  data() {
    return {
      liked: this.is_liked,
      exItem: null,
    };
  },
  create() {
    this.liked = this.is_liked || false;
  },
  mounted() {
    this.decryptItem(this.item)
      .then((response) => {
        this.exItem = decrypt(response.data.item);
      })
      .catch((error) => {
        console.error('Decryption failed:', error);
      });
  },
  methods: {
    like() {
      if (this.auth) {
        var Counts = document.getElementsByClassName('movie-widget__value');
        var url = `/item/${this.exItem.id}/like`;
        if (this.has_episode) {
          url = `/item/${this.exItem.item_id}/like/${this.exItem.id}`;
        }

        axios
          .post(url)
          .then((response) => {
            this.liked = !this.liked;
            Counts[0].innerHTML =
              Number(Counts[0].innerHTML) + Number(response.data.value);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        notify('Please you need to login first', 'warning');
      }
    },

    decryptItem(item) {
      const apiUrl = `/decrypt-item`;
      return axios.post(apiUrl, {
        item: item,
      });
    },
  },
};
</script>

<style scoped>
.likes-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 15px;

  /* padding: 5px 5px; */
  background-color: var(--color-grayish);
}
.movie-widget {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  cursor: pointer;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border-right: solid 1px #aeb2bd57;
}
.movie-widget:hover {
  background-color: var(--bg-hover-color);
}
.text--white {
  color: #fff;
}
@media screen and (max-width: 360px) {
  .movie-widget {
    padding: 0px 7px;
  }
  i {
    font-size: 15px;
  }
}

i {
  margin-right: 5px;
  font-size: 25px;
}
.movie-widget__value {
  font-size: 14px;
  font-weight: bold;
  /* color: #aeb2bd; */
  color: #fff;
  margin-left: 5px;
  margin-right: 5px;
}
.dislike {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: solid 0px #aeb2bd;
  border-right: none;
}
</style>
